var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aaa"},[_c('div',{staticClass:"home"}),_c('PopUP',{attrs:{"flage":_vm.flage},on:{"hide":_vm.hide}}),_c('div',{staticClass:"lists"},_vm._l((_vm.list),function(item,i){return _c('div',{key:i,staticClass:"lisy-now",class:{ colrs: i == _vm.keys },style:({
        backgroundImage: _vm.keys == i ? `url(${_vm.images})` : `url(${item.image})`,
      }),on:{"click":function($event){return _vm.app(i)}}},[_vm._v(" "+_vm._s(item.nama)+" ")])}),0),_c('titlE'),_c('towbotM'),_c('subject')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }